module.exports = __webpack_public_path__ + "img/background-document-detail.f683534d.svg";